/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".img-viewer-pointer[_ngcontent-%COMP%]{position:absolute;left:36px;top:45%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:39px;height:84px;line-height:84px;background:#000;opacity:.7;font-size:60px;color:#fff;border-radius:8px;cursor:pointer}.img-viewer-no-more[_ngcontent-%COMP%]{cursor:not-allowed!important;opacity:.2!important}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/image.viewer/image.viewer.component.scss.shim.ngstyle.js.pre-build-optimizer.js